import { ServiceTypeFour } from "./ServiceTypeFour";
import { ServiceTypeOne } from "./ServiceTypeOne";
import { ServiceTypeThree } from "./ServiceTypeThree";

import { ServiceTypeTwo } from "./ServiceTypeTwo";

import { useTranslation } from "react-i18next";
import { useProfileStore } from "../../../store/useProfileStore";
import { useControlsStore } from "../../../store/useControlsStore";
import { useRatesStore } from "../../../store/useRatesStore";
import { useProfileDetailsStore } from "../../../store/useProfileDetailsStore";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { useErrorFieldStore } from "../../../store/useErrorsFieldsStore";
import { useDetailParentsStore } from "../../../store/useDetailParentsStore";
import { DateIcon } from "../../../assets/image/DateIcon";
import { TUTOR_FIELDS } from "../../../utils/variables";
import {ArrowUpIcon} from "../../../assets/image/ArrowUpIcon";
import React, {useState} from "react";

export function StepThreeContent({ updateProfile, afterLoginsField }) {
  const { t } = useTranslation();
  const [setMobile, setStep, setCalendarType, setProcess] = useControlsStore((state) => [
    state.setMobile,
    state.setStep,
    state.setCalendarType,
    state.setProcess,
  ]);
  const [errorField, setErrorField] = useErrorFieldStore((state) => [
    state.errorField,
    state.setErrorField,
  ]);
  const [detailParents, setDetailParents] = useDetailParentsStore((state) => [
    state.detailParents,
    state.setDetailParents,
  ]);

  const { nanyRate, generalRate, secondaryRate, tutorRate } = useRatesStore();

  const { qualifications } = useProfileDetailsStore();

  const detail = useProfileStore((state) => state.detail);

  const today = new Date();
  const [isCatOpen, setIsCatOpen] = useState(true);

  const handleElementById = (e, x) => {
    if (isCatOpen) {
      document.getElementById(e).style.display = "block";
      document.getElementById(x).style.display = "block";
      setIsCatOpen(false);
    } else {
      document.getElementById(e).style.display = "none";
      document.getElementById(x).style.display = "none";
      setIsCatOpen(true);
    }
  };

  return (
    <div className="detail preferences   work-experience job_performance setp3">
      {detail.service_type && detail.service_type.tab1 && <ServiceTypeOne />}

      {detail.service_type && detail.service_type.tab2 && <ServiceTypeTwo />}
      {detail.service_type && detail.service_type.tab3 && <ServiceTypeThree />}
      {detail.service_type && detail.service_type.tab4 && <ServiceTypeFour />}
      <div className="general_info tutor  preferred_school_jobs parents2">
        <h2 className="border">{t("general-info")}</h2>
        <div className="form_group full">
          <label>
            {t("work-experience-preffer")}
            <span className={errorField.tutorexp && errorField.tutorexp !== "" ? "starred" : ""}>
              *
            </span>
          </label>

          <div className="customselect inp">
            <input
                className="keyword"
                type="text"
                placeholder={t("choose-list")}
                value={
                  detailParents.tutorexp != ""
                      ? t(detailParents.tutorexp)
                      : t("choose-list")
                }
            />
            <div
                className="overflow"
                id="over1"
                onClick={(e) => handleElementById("cate1", "over1")}
            ></div>

            <div
                className="option"
                id="cate1"
                onClick={(w) =>
                    setErrorField({
                      ...errorField,
                      tutorexp: "",
                    })
                }
            >
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.tutorexp) === t("years-0-1")
                    }
                    onClick={() => setDetailParents({tutorexp: "years-0-1"})}
                />
                <h3>{t("years-0-1")} </h3>
                <span></span>
              </p>
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.tutorexp) === t("years-1-2")
                    }
                    onClick={() => setDetailParents({tutorexp: "years-1-2"})}
                />
                <h3>{t("years-1-2")} </h3>
                <span></span>
              </p>
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.tutorexp) === t("years-2-4")
                    }
                    onClick={() => setDetailParents({tutorexp: "years-2-4"})}
                />
                <h3>{t("years-2-4")} </h3>
                <span></span>
              </p>
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.tutorexp) === t("years-4-more")
                    }
                    onClick={() => setDetailParents({tutorexp: "years-4-more"})}
                />
                <h3>{t("years-4-more")} </h3>
                <span></span>
              </p>
            </div>

            <span
                onClick={(e) => handleElementById("cate1", "over1")}
            >
                          <ArrowUpIcon />
                        </span>
          </div>
        </div>

        <div className="form_group full">
          <label>
            {t("age-provider-preffer")}
            <span
              className={
                errorField.preferredageofprovider && errorField.preferredageofprovider !== "" ? "starred" : ""
              }
            >
              *
            </span>
          </label>
          <div className="customselect inp">
            <input
                className="keyword"
                type="text"
                placeholder={t("choose-list")}
                value={
                  detailParents.preferredageofprovider != ""
                      ? t(detailParents.preferredageofprovider)
                      : t("choose-list")
                }
            />
            <div
                className="overflow"
                id="over5"
                onClick={(e) => handleElementById("cate5", "over5")}
            ></div>

            <div
                className="option"
                id="cate5"
                onClick={(w) =>
                    setErrorField({
                      ...errorField,
                      preferredageofprovider: "",
                    })
                }
            >
              <p>
                <input
                    type="checkbox"
                    checked={
                      t(detailParents.preferredageofprovider) === t("years-18-23")
                    }
                    onClick={() => setDetailParents({preferredageofprovider: "years-18-23"})}
                />
                <h3>{t("years-18-23")} </h3>
                <span></span>
              </p>
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.preferredageofprovider) === t("years-24-30")
                    }
                    onClick={() => setDetailParents({preferredageofprovider: "years-24-30"})}
                />
                <h3>{t("years-24-30")} </h3>
                <span></span>
              </p>
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.preferredageofprovider) === t("years-31-40")
                    }
                    onClick={() => setDetailParents({preferredageofprovider: "years-31-40"})}
                />
                <h3>{t("years-31-40")} </h3>
                <span></span>
              </p>
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.preferredageofprovider) === t("years-40")
                    }
                    onClick={() => setDetailParents({preferredageofprovider: "years-40"})}
                />
                <h3>{t("years-40")} </h3>
                <span></span>
              </p>
              <p>
                <input
                    type="checkbox"
                    checked={
                        t(detailParents.preferredageofprovider) === t("text-any")
                    }
                    onClick={() => setDetailParents({preferredageofprovider: "text-any"})}
                />
                <h3>{t("text-any")} </h3>
                <span></span>
              </p>
            </div>

            <span
                onClick={(e) => handleElementById("cate5", "over5")}
            >
                          <ArrowUpIcon />
                        </span>
          </div>
        </div>
        <div className="form_group full">
          <label>
            {t("start-date")}
            <span className={errorField.tutorstartdate && errorField.tutorstartdate !== "" ? "starred" : ""}>
              *
            </span>
          </label>
          <div className="date_cal parents_cal">
            <span>
              <DateIcon />
            </span>
            <DatePicker
              className={errorField.tutorstartdate && errorField.tutorstartdate !== "" ? "bordererror" : ""}
              minDate={today}
              selected={
                detailParents.tutorstartdate != null &&
                detailParents.tutorstartdate != ""
                  ? new Date(`${detailParents.tutorstartdate}T00:00:00`)
                  : today
              }
              onChange={(date) => {
                setErrorField({ tutorstartdate: "" });

                const selectedDate = new Date(
                    date.getFullYear(),
                    date.getMonth(),
                    date.getDate()
                );

                setDetailParents({
                  tutorstartdate:
                      selectedDate.getFullYear() +
                    "-" +
                    String(selectedDate.getMonth() + 1).padStart(2, "0") +
                    "-" +
                    String(selectedDate.getDate()).padStart(2, "0"),
                });
              }}
            />
          </div>
        </div>
        <div className="form_group full">
          <label>
            {t("text-frequency")}
            <span
              className={errorField.tutorintrestedin && errorField.tutorintrestedin !== "" ? "starred" : ""}
            >
              *
            </span>
          </label>
          <div className="checkbox create">
            <ul
              onClick={(e) =>
                setErrorField({ tutorintrestedin: "" })
              }
            >
              <li>
                <input
                  type="radio"
                  name="a"
                  checked={
                    detailParents.tutorintrestedin == t("full-time")
                      ? true
                      : false
                  }
                  onClick={(e) =>
                    setDetailParents({
                      tutorintrestedin: t("full-time"),
                    })
                  }
                />
                <span> {t("full-time")}</span>
              </li>
              <li>
                <input
                  type="radio"
                  name="a"
                  checked={
                    detailParents.tutorintrestedin == t("part-time")
                      ? true
                      : false
                  }
                  onClick={(e) =>
                    setDetailParents({
                      tutorintrestedin: t("part-time"),
                    })
                  }
                />
                <span> {t("part-time")}</span>
              </li>
              <li>
                <input
                  type="radio"
                  name="a"
                  checked={
                    detailParents.tutorintrestedin == t("occasionally")
                      ? true
                      : false
                  }
                  onClick={(e) =>
                    setDetailParents({
                      tutorintrestedin: t("occasionally"),
                    })
                  }
                />
                <span> {t("occasionally")}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="button">
        <button
          onClick={(e) => {
            setStep(2);
            setMobile(-20);
            window.scrollTo({ top: 0 });
          }}
        >
          {t("text-back")}
        </button>
        <button
          onClick={(e) => {
            if (
              (detail.service_type && detail.service_type.tab1
                ? detailParents.liveinnany != "" && nanyRate.max > 5
                : detailParents.tutorexp != "") &&
              (detail.service_type && detail.service_type.tab4
                ? (qualifications.English ||
                    qualifications.Serbian ||
                    qualifications.Mathematics ||
                    qualifications.Physics ||
                    qualifications.Chemistry ||
                    qualifications.Other) &&
                  detailParents.tutorintrestedonlinecls != "" &&
                  tutorRate.max > 5
                : detailParents.tutorexp != "") &&
              detailParents.tutorexp != "" &&
              detailParents.preferredageofprovider != "" &&
              detailParents.tutorstartdate != "" &&
              detailParents.tutorintrestedin &&
              (detail.service_type && detail.service_type.tab2
                ? generalRate.max > 5
                : detailParents.tutorintrestedin) &&
              (detail.service_type && detail.service_type.tab3
                ? secondaryRate.max > 5
                : detailParents.tutorintrestedin)
            ) {
              setStep(4);
              setProcess(57);
              setMobile(-32);
              window.scrollTo({ top: 0 });
              updateProfile(false);
              setTimeout(() => {
                setCalendarType(detailParents.calanderlastupdate);
              }, 500);
            } else {
              TUTOR_FIELDS.map((e) => {
                afterLoginsField(e.name);
              });
            }
          }}
        >
          {t("text-next")}
        </button>
      </div>
    </div>
  );
}
